<template>
    <div class="verify-email-page">
        <div class="fd-list-header">
            <h1 class="fd-list-header__brand">Redhill Food Distribution</h1>
        </div>

        <div class="card">
            <div class="card-content has-text-centered">
                <div class="mb-4">
                    <span class="icon is-large has-text-info">
                        <i class="fas fa-envelope fa-2x"></i>
                    </span>
                </div>
                <h1 class="title is-5">Verify your email</h1>
                <p class="mb-4">
                    We sent a verification link to <strong>{{ userEmail }}</strong>.
                    Click the link in the email to activate your account.
                    If you can't find it, check your <strong>spam or junk folder</strong>.
                </p>

                <div v-if="notVerifiedYet" class="notification is-warning is-light mb-4">
                    <p>Not verified yet — please check your inbox and try again.</p>
                </div>

                <div class="buttons is-centered">
                    <button class="button is-primary"
                        :class="{ 'is-loading': isChecking }"
                        :disabled="isChecking"
                        @click="checkVerified">
                        I've verified my email
                    </button>
                    <button class="button is-light"
                        :class="{ 'is-loading': isResending }"
                        :disabled="isResending"
                        @click="resend">
                        Resend email
                    </button>
                </div>

                <p v-if="resendMessage" class="has-text-success mt-2">{{ resendMessage }}</p>

                <div class="mt-5">
                    <a class="has-text-grey" @click="signOut">Sign out</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { auth } from '@/firebase/firebaseInit';
import { signOut } from 'firebase/auth';

export default {
    data() {
        return {
            isChecking: false,
            isResending: false,
            notVerifiedYet: false,
            resendMessage: null
        }
    },
    computed: {
        userEmail() {
            return auth.currentUser?.email || '';
        }
    },
    methods: {
        async checkVerified() {
            this.isChecking = true;
            this.notVerifiedYet = false;
            this.resendMessage = null;
            try {
                await auth.currentUser.reload();
                if (auth.currentUser.emailVerified) {
                    await this.$store.dispatch('user/loadUserProfile');
                    this.$router.push('/');
                } else {
                    this.notVerifiedYet = true;
                }
            } catch (error) {
                console.error(error);
            }
            this.isChecking = false;
        },
        async resend() {
            this.isResending = true;
            this.resendMessage = null;
            try {
                await this.$store.dispatch('user/resendVerificationEmail');
                this.resendMessage = 'Verification email sent!';
            } catch (error) {
                this.resendMessage = error.message || 'Failed to resend email.';
            }
            this.isResending = false;
        },
        async signOut() {
            await signOut(auth);
            this.$router.push('/login');
        }
    }
}
</script>

<style scoped>
.verify-email-page {
    text-align: center;
    max-width: 400px;
    padding: 20px;
    margin: 0 auto;
}

.fd-list-header {
    text-align: center;
    padding: 1.25rem 0 0.5rem;
}

.fd-list-header__brand {
    font-size: 1.6rem;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.5px;
}

.card {
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    border-radius: 8px;
    border: none;
}
</style>
